module.exports = __webpack_public_path__ + "static/media/SW-Logo-White.b9dd2c1d.svg";